var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Button, Typography } from '@mui/material';
import StatCard from '../StatCard/StatCard';
import GameStat from '../GameStat/GameStat';
import WordsStat from '../WordsStat/WordsStat';
import AccuracyStat from '../AccuracyStat/AccuracyStat';
import api from './../../../utils/AuthAPI';
import localStorageService from './../../../utils/LocalStorageService';
import AuthConstants from '../../../constants/Auth.constants';
import classes from './Statistic.module.css';
import { TotalWordsGraph } from './../../statistics/longStat/TotalWordsGraph/TotalWordsGraph';
var dataNewWords = {
    labels: ['0'],
    datasets: [
        {
            label: 'новых за весь период обучения',
            data: [0],
            borderColor: 'blue',
            backgroundColor: 'blue',
        },
    ],
};
var dataLeanedWords = {
    labels: ['0'],
    datasets: [
        {
            label: 'изученных за весь период обучения',
            data: [0],
            borderColor: 'brown',
            backgroundColor: 'brown',
        },
    ],
};
var Statistic = function () {
    var _a, _b;
    var _c = useState(null), stat = _c[0], setStat = _c[1];
    var _d = useState(false), showStat = _d[0], setShowStat = _d[1];
    var _e = useState(null), averages = _e[0], setAverages = _e[1];
    useEffect(function () {
        var local = localStorageService.getItem(AuthConstants.USER_KEY_STORAGE);
        if (local) {
            ;
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var id, token, response, result, archiveStatDB, percentageSprint, percentageAudioChallenge, learnedWords, answersSprint, answersAudioChallenge, averagePercentage, averageAnswers, averageValues;
                var _a, _b, _c, _d, _e, _f, _g, _h;
                return __generator(this, function (_j) {
                    switch (_j.label) {
                        case 0:
                            id = local.userId;
                            token = local.token;
                            return [4 /*yield*/, api.getStat(id, token)];
                        case 1:
                            response = _j.sent();
                            if (!(response && response.status === 200)) return [3 /*break*/, 3];
                            return [4 /*yield*/, response.json()];
                        case 2:
                            result = _j.sent();
                            delete result.id;
                            if (result &&
                                result.optional &&
                                result.optional.long &&
                                typeof result.optional.long === 'string') {
                                archiveStatDB = JSON.parse(result.optional.long);
                                if (archiveStatDB) {
                                    dataNewWords.labels = __spreadArray([
                                        '0'
                                    ], archiveStatDB
                                        .map(function (item) { return new Date(item.date).toLocaleDateString(); })
                                        .reverse(), true);
                                    dataNewWords.datasets[0].data = __spreadArray([
                                        0
                                    ], archiveStatDB.map(function (item) { return +item.new; }).reverse(), true);
                                    dataLeanedWords.labels = __spreadArray([
                                        '0'
                                    ], archiveStatDB
                                        .map(function (item) { return new Date(item.date).toLocaleDateString(); })
                                        .reverse(), true);
                                    dataLeanedWords.datasets[0].data = __spreadArray([
                                        0
                                    ], archiveStatDB.map(function (item) { return +item.learned; }).reverse(), true);
                                }
                            }
                            percentageSprint = (_b = (_a = result.optional) === null || _a === void 0 ? void 0 : _a.sprint) === null || _b === void 0 ? void 0 : _b.percentage;
                            percentageAudioChallenge = (_d = (_c = result.optional) === null || _c === void 0 ? void 0 : _c.audiochallenge) === null || _d === void 0 ? void 0 : _d.percentage;
                            learnedWords = result.learnedWords;
                            answersSprint = (_f = (_e = result.optional) === null || _e === void 0 ? void 0 : _e.sprint) === null || _f === void 0 ? void 0 : _f.newWords;
                            answersAudioChallenge = (_h = (_g = result.optional) === null || _g === void 0 ? void 0 : _g.audiochallenge) === null || _h === void 0 ? void 0 : _h.newWords;
                            if (percentageSprint !== undefined &&
                                percentageAudioChallenge !== undefined &&
                                answersSprint !== undefined &&
                                answersAudioChallenge !== undefined) {
                                averagePercentage = percentageSprint && percentageAudioChallenge > 0
                                    ? Math.ceil((+(percentageSprint + percentageAudioChallenge).toFixed(2) *
                                        100) /
                                        2)
                                    : Math.ceil(+(percentageSprint + percentageAudioChallenge).toFixed(2) *
                                        100);
                                averageAnswers = answersSprint + answersAudioChallenge;
                                averageValues = {
                                    learnedWords: learnedWords,
                                    averagePercentage: averagePercentage,
                                    averageAnswers: averageAnswers,
                                };
                                setAverages(averageValues);
                            }
                            setStat(result);
                            setShowStat(true);
                            _j.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); })();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showStat]);
    return (React.createElement(React.Fragment, null, showStat && stat && averages ? (React.createElement("div", { className: classes.content },
        React.createElement("div", { className: classes.btns },
            React.createElement(Typography, { className: classes.title, variant: "h2", component: "h2" }, "\u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430"),
            React.createElement(Link, { to: "/", style: { textDecoration: 'none' } },
                React.createElement(Button, { variant: "contained" }, "\u041D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E"))),
        React.createElement("div", { style: {
                width: '100%',
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
            } },
            React.createElement("div", null,
                React.createElement(StatCard, { width: 300, height: 300 },
                    React.createElement(WordsStat, { learnedWords: averages.learnedWords || 0, averageAnswers: averages.averageAnswers || 0 })),
                React.createElement(StatCard, { width: 300, height: 300 },
                    React.createElement(AccuracyStat, { averagePercentage: averages.averagePercentage || 0 }))),
            React.createElement("div", null,
                React.createElement(StatCard, { width: 500, height: 300 },
                    React.createElement(GameStat, { title: "\u0410\u0443\u0434\u0438\u043E\u0432\u044B\u0437\u043E\u0432", cn: "audio", game: (_a = stat.optional) === null || _a === void 0 ? void 0 : _a.audiochallenge })),
                React.createElement(StatCard, { width: 500, height: 300 },
                    React.createElement(GameStat, { title: "\u0421\u043F\u0440\u0438\u043D\u0442", cn: "sprint", game: (_b = stat.optional) === null || _b === void 0 ? void 0 : _b.sprint })))),
        React.createElement("div", { style: {
                width: '90vw',
                margin: '0 auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            } },
            React.createElement(TotalWordsGraph, { data: dataNewWords }),
            React.createElement(TotalWordsGraph, { data: dataLeanedWords })))) : (React.createElement(Typography, { className: classes.fail, variant: "h4", component: "h2" }, "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0442\u043E\u043B\u044C\u043A\u043E \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u0432\u043E\u0439\u0434\u0438\u0442\u0435 \u0432 \u0432\u0430\u0448 \u0430\u043A\u043A\u0430\u0443\u043D\u0442"))));
};
export default Statistic;
